<template>
  <div class="customer-list">
    <CCard>
      <CCardHeader>
        <strong>لیست مشتریان</strong>
        <div class="header-actions">
          <CButton color="success" size="sm" @click="exportToExcel" class="mr-2">
            <CIcon name="cil-file-excel"/> خروجی اکسل
          </CButton>
        </div>
      </CCardHeader>

      <CCardBody>
        <!-- Filters -->
        <CRow class="mb-3">
          <CCol md="4" sm="6" xs="12" class="mb-2">
            <CButton
                color="primary"
                block
                @click="toggleFilter('cancellation')"
                :class="{ 'active-filter': activeFilter === 'cancellation' }"
                class="filter-btn"
            >
              <CIcon name="cil-filter"/> لغو کمتر از ۳۰٪
              <CBadge v-if="activeFilter === 'cancellation'" color="light" class="mr-1">
                {{ filteredCustomers.length }}
              </CBadge>
            </CButton>
          </CCol>
          <CCol md="4" sm="6" xs="12" class="mb-2">
            <CButton
                color="warning"
                block
                @click="toggleFilter('oneMonth')"
                :class="{ 'active-filter': activeFilter === 'oneMonth' }"
                class="filter-btn"
            >
              <CIcon name="cil-clock"/> یک ماه رزرو نکرده
              <CBadge v-if="activeFilter === 'oneMonth'" color="light" class="mr-1">
                {{ filteredCustomers.length }}
              </CBadge>
            </CButton>
          </CCol>
          <CCol md="4" sm="6" xs="12" class="mb-2">
            <CButton
                color="danger"
                block
                @click="toggleFilter('twoMonths')"
                :class="{ 'active-filter': activeFilter === 'twoMonths' }"
                class="filter-btn"
            >
              <CIcon name="cil-clock"/> دو ماه رزرو نکرده
              <CBadge v-if="activeFilter === 'twoMonths'" color="light" class="mr-1">
                {{ filteredCustomers.length }}
              </CBadge>
            </CButton>
          </CCol>
          <CCol md="4" sm="6" xs="12" class="mb-2">
          <CSelect :options="[{label:'اخرین رزرو',value:0},{label:'بیشترین رزرو',value:1},{label:'کمترین رزرو',value:2},]"
          :value.sync="selected_sort"
          />
          </CCol>
        </CRow>

        <!-- Filter Result Count -->
        <CAlert v-if="activeFilter" color="info" class="text-center">
          <strong>تعداد مشتریان با این فیلتر: {{ filteredCustomers.length }} نفر</strong>
        </CAlert>

        <!-- Customer Cards - Responsive Grid with 2 columns -->
        <CRow v-if="displayCustomers.length > 0">
          <CCol @click="open_customer_modal(customer)"
              v-for="(customer, index) in displayCustomers"
              :key="customer.id"
              lg="6"
              md="6"
              sm="12"
              xs="12"
              class="mb-3"
          >
            <CCard class="customer-card h-100">
              <CCardHeader class="align-items-center" style="display: flex!important;justify-content: space-between!important;    flex-flow: nowrap;">
                <h5 class="mb-0">{{ customer.name }}</h5>
                <CBadge :color="getStatusColor(customer)" pill>
                  {{ getStatusText(customer) }}
                </CBadge>
              </CCardHeader>
              <CCardBody>
                <div class="customer-info two-column">
                  <div class="info-row">
                    <span class="info-label">شماره همراه:</span>
                    <span class="info-value">{{ customer.phone }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">تاریخ ثبت نام:</span>
                    <span class="info-value">{{ get_date_time(customer.created_at) }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">آخرین رزرو:</span>
                    <span class="info-value">{{ get_date_time(customer.last_order_date) }}</span>
                  </div>
                  <div class="">
                    <CRow>
                      <CCol>
                        <div class="info-row">

                        <span class="info-label">تعداد رزرو:</span>
                        <span class="info-value">{{ customer.orders_count }}</span>
                        </div>
                      </CCol>
                      <CCol>
                        <div class="info-row">
                          <span class="info-label">موفق:</span>
                          <span class="info-value text-success">{{ customer.approved_orders_count }}</span>
                        </div>
                      </CCol>
                      <CCol>
                        <div class="info-row">
                          <span class="info-label">کنسلی:</span>
                          <span class="info-value text-danger">{{ customer.canceled_orders_count }}</span>
                        </div>
                      </CCol>
                      <CCol>
                        <div class="info-row">
                          <span class="info-label">درصد لغو:</span>
                          <span class="info-value" :class="getCancellationClass(customer)">
                      {{ getCancellationPercentage(customer) }}%
                    </span>
                        </div>
                      </CCol>
                    </CRow>

                  </div>



                </div>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>

        <!-- Empty State -->
        <CAlert v-else color="info" class="text-center">
          <h5>هیچ مشتریی با این فیلتر یافت نشد</h5>
        </CAlert>
      </CCardBody>
    </CCard>
    <CModal
        title="رزرو های مشتری"
        color="primary"
        :show.sync="show_customer_detail"
    >
      <CRow>
        <CCol col="12">
<div v-for="order in selected_customer.orders">
  <div class="info-row">
    <span class="info-label">رزرو:</span>
    <span class="info-value">{{ get_date_time(order.reserve_time.date) }}</span>
    <span class="info-value text-danger" v-if="order.status==0">لغو شده</span>
    <span class="info-value text-success" v-if="order.status!=0">تایید شده</span>
  </div>
</div>
        </CCol>
      </CRow>
      <template #footer>
        <CButton @click="show_customer_detail = false" color="dark">{{$t('close')}}</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import * as XLSX from 'xlsx';
import {bus} from "../../main";

export default {
  name: 'CustomerList',
  data() {
    return {
      items: [],
      selected_sort:0,
      show_customer_detail:false,
      selected_customer:{},
      activeFilter: null,
      filteredCustomers: [],
    }
  },
  computed: {
    displayCustomers() {
      let cus = this.activeFilter ? this.filteredCustomers : this.items;
      if(this.selected_sort==0){
        cus.sort((a, b) => b.last_order_date.localeCompare(a.last_order_date))
      }if(this.selected_sort==1){
        cus.sort((a, b) => b.orders_count- (a.orders_count))

      }if(this.selected_sort==2){
        cus.sort((a, b) => a.orders_count- (b.orders_count))

      }


      return cus
    }
  },
  mounted() {
    this.getCustomers();
  },
  methods: {
    open_customer_modal(customer){
      // this.selected_customer=customer
      // this.show_customer_detail=true
    bus.$emit('open_customer_data',{'customer_id':customer.id})
    },
    getCustomers() {
      axios.post('/api/admin/user/get_my_customers', {})
          .then(response => {
            this.items = response.data.map(customer => ({
              ...customer,
              last_order_date: customer.last_order?.reserve_time?.date || null
            }));
          })
          .catch(error => {
            console.error('Error fetching customers:', error);
          });
    },

    // Toggle Filter - Click again to deactivate
    toggleFilter(filterType) {
      if (this.activeFilter === filterType) {
        // If same filter is clicked, deactivate it
        this.activeFilter = null;
        this.filteredCustomers = [];
      } else {
        // Apply new filter
        this.activeFilter = filterType;
        this.applyFilter(filterType);
      }
    },

    applyFilter(filterType) {
      const now = new Date();

      switch(filterType) {
        case 'cancellation':
          this.filteredCustomers = this.items.filter(customer => {
            const total = customer.orders_count || 0;
            const canceled = customer.canceled_orders_count || 0;
            const percentage = total > 0 ? (canceled / total) * 100 : 0;
            return percentage < 30;
          });
          break;

        case 'oneMonth':
          this.filteredCustomers = this.items.filter(customer => {
            if (!customer.last_order_date) return true;
            const lastOrder = new Date(customer.last_order_date);
            const diffTime = Math.abs(now - lastOrder);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            return diffDays > 30;
          });
          break;

        case 'twoMonths':
          this.filteredCustomers = this.items.filter(customer => {
            if (!customer.last_order_date) return true;
            const lastOrder = new Date(customer.last_order_date);
            const diffTime = Math.abs(now - lastOrder);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            return diffDays > 60;
          });
          break;

        default:
          this.filteredCustomers = [];
      }
    },

    // Helper Methods
    getCancellationPercentage(customer) {
      const total = customer.orders_count || 0;
      const canceled = customer.canceled_orders_count || 0;
      return total > 0 ? Math.round((canceled / total) * 100) : 0;
    },

    getCancellationClass(customer) {
      const percentage = this.getCancellationPercentage(customer);
      if (percentage < 30) return 'text-success';
      if (percentage < 50) return 'text-warning';
      return 'text-danger';
    },

    getStatusColor(customer) {
      const percentage = this.getCancellationPercentage(customer);
      if (percentage < 30) return 'success';
      if (percentage < 50) return 'warning';
      return 'danger';
    },

    getStatusText(customer) {
      const percentage = this.getCancellationPercentage(customer);
      if (percentage < 30) return 'عالی';
      if (percentage < 50) return 'متوسط';
      return 'ضعیف';
    },

    get_date_time(date) {
      if (!date) return '—';
      return new Date(date).toLocaleDateString('fa-IR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    // Excel Export
    exportToExcel() {
      const customersToExport = this.displayCustomers;

      if (customersToExport.length === 0) {
        alert('هیچ مشتریی برای خروجی وجود ندارد');
        return;
      }

      const exportData = customersToExport.map(customer => ({
        'شناسه': customer.id,
        'نام و نام خانوادگی': customer.name,
        'شماره همراه': customer.phone,
        'تاریخ ثبت نام': this.get_date_time(customer.created_at),
        'آخرین رزرو': this.get_date_time(customer.last_order_date),
        'تعداد رزرو': customer.orders_count || 0,
        'رزرو موفق': customer.approved_orders_count || 0,
        'رزرو کنسلی': customer.canceled_orders_count || 0,
        'درصد لغو': this.getCancellationPercentage(customer) + '%'
      }));

      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'مشتریان');

      ws['!cols'] = [
        {wch: 10}, {wch: 20}, {wch: 15}, {wch: 20},
        {wch: 20}, {wch: 12}, {wch: 12}, {wch: 12}, {wch: 12}
      ];

      const fileName = `مشتریان_${new Date().toLocaleDateString('fa-IR')}.xlsx`;
      XLSX.writeFile(wb, fileName);
    }
  }
}
</script>

<style scoped>
.customer-list {
  direction: rtl;
}

.header-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

/* Filter Button Styles */
.filter-btn {
  position: relative;
  transition: all 0.3s ease;
  font-weight: 500;
  border: 2px solid transparent;
}

.filter-btn.active-filter {
  transform: scale(1.02);
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
  border-color: #fff;
}

.filter-btn.active-filter.btn-primary {
  background-color: #321fdb;
  color: white;
  border-color: #321fdb;
}

.filter-btn.active-filter.btn-warning {
  background-color: #f9b115;
  color: white;
  border-color: #f9b115;
}

.filter-btn.active-filter.btn-danger {
  background-color: #e55353;
  color: white;
  border-color: #e55353;
}

.filter-btn .badge {
  font-size: 0.8rem;
  padding: 3px 8px;
}

/* Customer Card Styles */
.customer-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border-radius: 12px;
  overflow: hidden;
}

.customer-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.1);
}

.customer-card .card-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
  padding: 12px 16px;
}

.customer-card .card-header h5 {
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

/* Two Column Layout for Customer Info */
.customer-info.two-column {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 16px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px dashed #f1f3f5;
}

.info-row:last-child {
  border-bottom: none;
}

.info-label {
  font-weight: 500;
  color: #6c757d;
  font-size: 0.85rem;
}

.info-value {
  font-weight: 500;
  color: #2c3e50;
  font-size: 0.9rem;
}

.info-row {
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 6px 0;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .customer-info.two-column {
    grid-template-columns: 1fr;
  }

  .header-actions {
    margin-top: 8px;
    width: 100%;
    justify-content: flex-start;
  }

  .card-header {
    flex-direction: column;
    align-items: flex-start !important;
  }
}

@media (max-width: 576px) {
  .customer-card .card-header {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }

  .customer-card .card-header h5 {
    font-size: 1.1rem;
  }

  .info-label {
    font-size: 0.8rem;
  }

  .info-value {
    font-size: 0.9rem;
  }
}

/* Badge Styles */
.badge {
  font-size: 0.8rem;
  padding: 5px 10px;
}

/* Animation for cards */
.customer-card {
  animation: fadeInUp 0.3s ease;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Alert for filter count */
.alert {
  margin-bottom: 16px;
  border-radius: 8px;
}
</style>